import React from "react"
import AuthBackground from "../components/auth/authBackground"
import AuthCard from "../components/auth/authCard"
import UserRegisterForm from "../components/auth/userRegisterForm"
import RecaptchaProvider from "../components/recaptcha/RecaptchaProvider"

const UserRegisterPage = () => {
  return (
    <RecaptchaProvider>
      <div className="container-fluid relative h-screen mx-auto flex justify-center items-center bg-cream max-md:text-sm">
        <AuthCard>
          <UserRegisterForm />
        </AuthCard>
        <AuthBackground />
      </div>
    </RecaptchaProvider>
  )
}

export default UserRegisterPage
